<template>
  <section>
    <div class="row mt-2">
      <div class="form-group col-md-6">
        <dt-input
          v-model="username"
          name="username"
          autocomplete="new-password"
          label="Username (email address)"
          validate="required"
        />
      </div>
      <div class="form-group col-md-6">
        <dt-select
          v-model="contactType"
          name="contactType"
          label="Contact Type"
          :options="lookups['UserContactType']"
          validate="required"
        />
      </div>
    </div>
    <div
      class="row mt-2"
      v-if="isAdd"
    >
      <div class="form-group col-md-6">
        <dt-input
          type="password"
          v-model="password"
          autocomplete="new-password"
          name="password"
          label="Password"
          validate="required"
          @blur="verifyPassword"
        />
      </div>
      <div class="form-group col-md-6">
        <dt-input
          v-model="newpassword"
          autocomplete="new-password"
          name="newpassword"
          label="Password (again)"
          validate="required"
          @blur="verifyPassword"
        />
      </div>
    </div>
    <div class="row">
      <div class="form-group col-md-6">
        <dt-select
          v-model="role"
          name="role"
          label="User Role"
          :options="roles"
          validate="required"
        />
      </div>
      <div class="form-group col-md-6">
        <dt-input
          v-model="laborRate"
          name="laborRate"
          label="Labor Rate (per hr)"
          type="number"
          validate="required"
        />
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import DtInput from '@/components/utilities/form/dt-input'
import DtSelect from '@/components/utilities/form/dt-select'
export default {
  name: 'user-info',
  components: {
    DtInput,
    DtSelect
  },
  props: {
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      newpassword: ''
    }
  },
  computed: {
    ...mapGetters('users', ['user', 'roles']),
    ...mapGetters('lookups', ['lookups']),
    username: {
      get() {
        return this.user !== null ? this.user.username : ''
      },
      set(value) {
        this.updateUser({
          name: 'username',
          value: value
        })
      }
    },
    password: {
      get() {
        return this.user !== null ? this.user.password : ''
      },
      set(value) {
        this.updateUser({
          name: 'password',
          value: value
        })
      }
    },
    contactType: {
      get() {
        return this.user !== null ? this.user.contactType : 0
      },
      set(value) {
        this.updateUser({
          name: 'contactType',
          value: value
        })
      }
    },
    role: {
      get() {
        let _role = 0
        if (this.user !== null) {
          if (this.user.roles !== null) {
            if (this.user.roles.indexOf(',') > 0) {
              var roles = this.user.roles.split(',')
              _role = roles[0]
            } else {
              _role = this.user.roles
            }
          }
        }
        return _role
      },
      set(value) {
        this.updateUser({
          name: 'role',
          value: value
        })
      }
    },
    laborRate: {
      get() {
        return this.user !== null ? this.user.laborRate : ''
      },
      set(value) {
        this.updateUser({
          name: 'laborRate',
          value: value
        })
      }
    }
  },
  methods: {
    ...mapActions('users', ['updateUser']),
    validatePassword() {
      let valid = true
      this.reason = ''
      if (this.isLoading === false && this.password !== '') {
        let strongRegex = new RegExp(
          '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'
        )
        valid = strongRegex.test(this.password)
        if (valid === false) {
          this.reason =
            "Password doesn't meet minimum strength of special characters (!@#$%^&*), lower case (a-z), upper case (A-Z) and numbers (0-9), and at least 8 characters in length."
        }
      }
      return valid
    },
    verifyPassword() {
      if (!this.validatePassword()) {
        alert(this.reason)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/users/forms/user-info.vue